import { extractErrorsIfBadRequest } from '@/features/pipelines/destinations';
import { isAxiosError } from 'axios';

export function getPreviewErrorMessage(error: unknown): string | undefined {
  if (error == null) {
    return undefined;
  }
  if (isAxiosError(error) && error.response?.status === 400) {
    const messages = extractErrorsIfBadRequest(error);
    const message = messages.length > 0 ? messages.join('\n') : String(error);
    // Surface a friendlier message for HubSpot scope errors
    if (message.includes('required scopes')) {
      return 'Preview is unavailable — the HubSpot connection is missing a required permission. Disconnect and reconnect the source to grant access.';
    }
    return message;
  }
  return String(error);
}
